// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".quote-cards-section[data-v-1be65288]{display:flex;flex-direction:row;justify-content:center;padding-left:0}ul.quote-cards-section[data-v-1be65288]{list-style:none}.offer-card-slide[data-v-1be65288]{margin:1px 10px 1px 10px;cursor:pointer}@media screen and (min-width: 700px){.quote-card-container[data-v-1be65288]{width:50%}}", ""]);
// Exports
module.exports = exports;
